export const TelegramIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000" {...props}>
    <defs>
      <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="99.26%">
        <stop offset="0%" stopColor="#2AABEE" />
        <stop offset="100%" stopColor="#229ED9" />
      </linearGradient>
    </defs>
    <circle cx="500" cy="500" r="500" fill="var(--icon-main, url(#a))" />
    <path
      fill="#FFF"
      d="M226.33 494.72c145.76-63.5 242.95-105.37 291.59-125.6 138.85-57.75 167.7-67.79 186.51-68.12 4.14-.07 13.39.96 19.38 5.82 5.05 4.1 6.45 9.65 7.11 13.54.67 3.89 1.5 12.75.84 19.68-7.53 79.06-40.08 270.92-56.65 359.48-7 37.46-20.8 50.03-34.17 51.26-29.04 2.67-51.08-19.2-79.2-37.63-44.01-28.84-68.87-46.8-111.59-74.95-49.37-32.53-17.36-50.41 10.77-79.63 7.36-7.65 135.3-124.01 137.77-134.57.31-1.32.6-6.24-2.33-8.84-2.92-2.6-7.23-1.71-10.35-1-4.41 1-74.71 47.47-210.9 139.4-19.96 13.7-38.03 20.37-54.22 20.03-17.86-.4-52.2-10.1-77.73-18.4-31.3-10.18-56.2-15.56-54.03-32.84 1.13-9 13.53-18.22 37.2-27.63Z"
    />
  </svg>
);
